import domready from 'domready'
import NewsletterBarController from './controllers/newsletter-bar-controller'

export default function initBackToTopController () {
  domready(() => {
    const element = document.querySelector('.newsletter-bar')
    if (element) {
      // eslint-disable-next-line no-new
      new NewsletterBarController(element)
    }
  })
}
